<div class="SLV2-main-wrapper">

    <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div>
    <div class="SLV2-home-right-body-wrap">

        <div class="SLV2-section-wrap lr-sm-padding SLV2-page-header-area homepage">
            <div class="SLV2-page-header-rgt" *ngIf="isUserFromLearn && userInfo.userDto.exams.length>1">
                <mat-form-field class="SLV2-grade-dropdown">
                    <mat-select [(value)]="examSelected" panelClass="gradeDropdownList right"
                        (selectionChange)="onExamSelect($event)">
                        <mat-option *ngFor="let exam of userUamExams" [value]=exam.examId>{{exam.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <button class="SLV2-grade-select-btn"> JEE Main - Grade 10 <img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button> -->
            </div>
        </div>

        <div class="SLV2-body-section-with-ads">
            <div class="SLV2-body-section">


                <!-- <div class="SLV2-section-wrap SLV2-page-header-area">
                    <div class="SLV2-page-header-lft">
            
                    </div>
                    <div class="SLV2-page-header-rgt">
                        <mat-form-field class="SLV2-grade-dropdown">
                            <mat-select [(value)]="examSelected" panelClass="gradeDropdownList" (selectionChange)="onExamSelect($event)">
                                <mat-option *ngFor="let exam of userInfo.userDto.exams" [value]=exam.examId>{{exam.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>  
                    </div>
                </div> -->


                <!-- Select a subject to start learning start -->
                <div class="SLV2-section-wrap with-btm-border first-section">
                    <div class="SLV2-section-head-section">
                        <h3 class="SLV2-section-heading">Select a subject to start learning</h3>
                    </div>
                    <ul class="SLV2-icon-subject-list" [ngClass]="{'expanded' : subjectViewMoreStatus}" [ngClass]="[subjectViewMoreStatus ? 'expanded' : '',  subjectNameList.length < 5 ? '' : '', ]">
                        <li *ngFor="let item of subjectNameList">
                            <app-iconic-subject (click)="navigateToSelectedSubject(item.nodeId, item.nodeName)" [subjectID]="item.nodeId" [subjectName]="item.nodeName" [icon]="item.icon">
                            </app-iconic-subject>
                        </li>
                        <li *ngIf="subjectNameList.length > 10" class="view-btn-li">
                            <div class="SLV2-viewmore-box" (click)="subjectViewMoreButton()">
                                <div class="SLV2-icn-box">
                                    <img *ngIf="!subjectViewMoreStatus" src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" />
                                    <img *ngIf="subjectViewMoreStatus" class="rotate" src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" />
                                </div>
                                <h4 class="SLV2-icn-subject-title">
                                    <ng-container *ngIf="!subjectViewMoreStatus">View More</ng-container>
                                    <ng-container *ngIf="subjectViewMoreStatus">View Less</ng-container>
                                </h4>
                            </div>
                        </li>
                    </ul>
                    <div class="SLV2-section-action-area subject-section"
                        [ngClass]="{'desktop-view' : subjectNameList.length > 10, 'mobile-view' : subjectNameList.length > 6}">
                        <button class="SLV2-subject-view-more-btn" [ngClass]="{'expanded' : subjectViewMoreStatus}"
                            (click)="subjectViewMoreButton()">
                            <ng-container *ngIf="!subjectViewMoreStatus">view more</ng-container>
                            <ng-container *ngIf="subjectViewMoreStatus">view less</ng-container>
                            <img src="selflearnv2-ui/assets/img/profile-drop-down-arrow.svg" />
                        </button>
                    </div>
                </div>
                <!-- Select a subject to start learning ended -->



                <div class="SLV2-all-section-wrapper">

                    <!-- Trending videos this week start -->
                    <div id="trendingDiv" *ngIf="selfLearnHomepagePlaylsit?.trendingVideosPlaylist?.length > 0" class="SLV2-section-wrap with-btm-border">
                        <div class="SLV2-section-head-section">
                            <h3 class="SLV2-section-heading">{{trendingVideosDisplayName}}</h3>
                            <button class="SLV2-viewall-link" *ngIf="selfLearnHomepagePlaylsit.trendingVideosPlaylist.length > 5" (click)="navigateToViewAllVideosList('Trending')">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                        </div>
                        <div class="SLV2-video-slider-area">
                            <carousel #myCarousel class="SLV2-video-carousel cell-padding" [height]="265" [margin]="6" [cellWidth]="300">
                                <div class="carousel-cell" *ngFor="let item of selfLearnHomepagePlaylsit.trendingVideosPlaylist">
                                    <app-video-card [videoData] ="item" (click)="navigatetoVideoPlayback(item, 'Trending')" [cardTitle]="item.title"></app-video-card>
                                </div>
                            </carousel>
                        </div>
                        
                    </div>
                    <!-- Trending videos this week ended -->


                    <!-- resume learning start -->
                    <div class="SLV2-section-wrap resume-learning" *ngIf="resumeLearningData?.status">
                        <div class="SLV2-section-head-section">
                            <h3 class="SLV2-section-heading">Resume Learning</h3>
                        </div>
                        <app-resume-learning-card class="home" [data]="resumeLearningData" [isFromHomeScreen]=true  [subjectData]="resumelearningSubject"></app-resume-learning-card>
                    </div>
                    <!-- resume learning ended -->


                    <!-- Recommended videos start -->
                    <div id="recommendedDiv" *ngIf="selfLearnHomepagePlaylsit?.recommendedVideosPlayList?.length > 0" class="SLV2-section-wrap with-btm-border">
                        <div class="SLV2-section-head-section">
                            <h3 class="SLV2-section-heading">{{recommendedVideosDisplayName}}</h3>
                            <button class="SLV2-viewall-link" *ngIf="selfLearnHomepagePlaylsit.recommendedVideosPlayList.length > 5" (click)="navigateToViewAllVideosList('Recommended')">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                        </div>
                        <div class="SLV2-video-slider-area">
                            <carousel #myCarousel class="SLV2-video-carousel cell-padding" [height]="265" [margin]="6" [cellWidth]="300">
                                <div class="carousel-cell" *ngFor="let item of selfLearnHomepagePlaylsit.recommendedVideosPlayList">
                                    <app-video-card [videoData] ="item" (click)="navigatetoVideoPlayback(item, 'Recommended')" [cardTitle]="item.title"></app-video-card>
                                </div>
                            </carousel>
                        </div>
                        
                    </div>
                    <!-- Recommended videos ended -->


                    <!-- Infinity Shorts start -->
                    <div id="shotsDiv" *ngIf="selfLearnHomepagePlaylsit?.shortsVideosPlayList?.length > 0" class="SLV2-section-wrap with-btm-border">
                        <div class="SLV2-section-head-section">
                            <h3 class="SLV2-section-heading">{{ilShortsDisplayName}}</h3>
                            <button class="SLV2-viewall-link" *ngIf="selfLearnHomepagePlaylsit.shortsVideosPlayList.length > 5" (click)="navigateToViewAllVideosList('ILShorts')">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                        </div>
                        <div class="SLV2-video-slider-area">
                            <carousel #myCarousel class="SLV2-video-carousel" [height]="310" [margin]="20" [cellWidth]="180">
                                <div class="carousel-cell" *ngFor="let item of selfLearnHomepagePlaylsit.shortsVideosPlayList">
                                    <app-shorts-card [videoData] ="item" (click)="navigatetoVideoPlayback(item, 'ILShorts')"  [cardTitle]="item.title"></app-shorts-card>
                                </div>
                            </carousel>
                        </div>
                        
                    </div>
                    <!-- Infinity Shorts ended -->


                    <!-- Puzzels start -->
                    <div id="puzzleDiv" *ngIf="selfLearnHomepagePlaylsit?.puzzleVideosPlayList?.length > 0" class="SLV2-section-wrap with-btm-border">
                        <div class="SLV2-section-head-section">
                            <h3 class="SLV2-section-heading">{{puzzlesDisplayName}}</h3>
                            <button class="SLV2-viewall-link" *ngIf="selfLearnHomepagePlaylsit.puzzleVideosPlayList.length > 5"  (click)="navigateToViewAllVideosList('Puzzles')">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button>
                        </div>
                        <div class="SLV2-video-slider-area">
                            <carousel #myCarousel class="SLV2-video-carousel cell-padding" [height]="265" [margin]="6" [cellWidth]="300">
                                <div class="carousel-cell" *ngFor="let item of selfLearnHomepagePlaylsit.puzzleVideosPlayList">
                                    <app-video-card [videoData] ="item" (click)="navigatetoVideoPlayback(item, 'Puzzles')" [cardTitle]="item.title"></app-video-card>
                                </div>
                            </carousel>
                        </div>
                        
                    </div>
                    <!-- Puzzels ended -->



                </div>
            </div>

  <app-ads-sidebar [isFromHomeScreen]=true *ngIf="flashCardids.length>0"></app-ads-sidebar>
        </div>
    </div>
    
</div>

